module.exports = __webpack_public_path__ + "img/volume.ebef9926.png";